import {Component, DestroyRef, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Heatmap, HeatmapOption, HeatmapResult} from '../../_types/polls';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ContentService} from '../../_services/content.service';
import {toBase64} from '../../_utils/utils';
import {from, Observable, of, switchMap} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {FormControl} from '@angular/forms';
import {PollsService} from '../../_services/polls.service';
import {HeatMapData} from '../heatmap/heatmap.component';
import {AuthService} from "../../_services/auth.service";
import {UserAccessLevel} from "../../_types/communities";
import {CommunitiesService} from "../../_services/communities.service";

@Component({
    selector: 'app-heatmap-vote-results',
    templateUrl: './heatmap-vote-results.component.html',
    styleUrl: './heatmap-vote-results.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeatmapVoteResultsComponent {

    heatmap!: Heatmap;
    image!: string;
    loaded: boolean = false;
    option: FormControl = new FormControl<number>(-1);
    options: HeatmapOption[] = [];

    constructor(
        private dialogRef: MatDialogRef<HeatmapVoteResultsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { heatmap: [Heatmap] },
        private pollsService: PollsService,
        private contentService: ContentService,
        private communitiesService: CommunitiesService,
        private destroyRef: DestroyRef,
        private readonly authService: AuthService,
    ) {
        if (data?.heatmap) {
            this.heatmap = data.heatmap[0];
            this.options = this.heatmap.options;
            this.loadImage(this.heatmap.image);
            this.pollsService.getHeatmapResults(this.heatmap.id).pipe(takeUntilDestroyed())
                .subscribe(res => {
                    this._votes = res || [];
                    this._clickData = this._votes.map(data => ({
                        x: Number(data.coordinate_x),
                        y: Number(data.coordinate_y),
                        intensity: 1
                    })) || [];
                    this.loaded = true;
                })
        }
    }

    _votes: HeatmapResult[] = [];

    get votes(): HeatmapResult[] {
        return this._votes.filter(vote => this.option.value === -1 ? true : vote.option === this.option.value);
    }

    _clickData: HeatMapData[] = [];

    get clickData(): HeatMapData[] {
        return this.votes.map(data => ({
            x: Number(data.coordinate_x),
            y: Number(data.coordinate_y),
            intensity: 1
        })) || [];
    }

    get isSuperuser(): boolean {
        return this.authService.isSuperUser();
    }

    getOption(option: number): HeatmapOption | undefined {
        return this.options.find(opt => opt.id === option);
    }

    getClickData(vote: HeatmapResult): HeatMapData[] {
        return [{x: Number(vote.coordinate_x), y: Number(vote.coordinate_y), intensity: 1}];
    }

    hasCommunityRole(roles: UserAccessLevel[]): boolean {
        return this.communitiesService.userHasCommunityRole(roles);
    }

    private loadImage(imageUrl: string): void {
        from(this.contentService.fetchFile(imageUrl)).pipe(
            switchMap((file: File): Observable<string> => from(toBase64(file) as Promise<string>)),
            catchError((error): Observable<null> => {
                console.error('Error loading image:', error);
                return of(null);
            }),
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((image: string | null): void => {
            if (image) {
                this.image = image;
            }
        });
    }

}
